import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=245e4d8d&scoped=true"
import script from "./Left.vue?vue&type=script&lang=js"
export * from "./Left.vue?vue&type=script&lang=js"
import style0 from "./Left.vue?vue&type=style&index=0&id=245e4d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e4d8d",
  null
  
)

export default component.exports